<script>import Blocks from "../../components/blocks/index";
import "../../functions/camel-to-kebab-case";
import { convertOrderNumberToString } from "./helpers";
export let grid = undefined;
export let oneAtATime = undefined;
export let items;
export let gridRowWidth = undefined;
export let builderBlock;
export let builderContext;
export let builderComponents;
export let builderLinkComponent = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
function getAccordionTitleClassName(index) {
    return `builder-accordion-title builder-accordion-title-${open.includes(index) ? "open" : "closed"}`;
}
function getAccordionDetailClassName(index) {
    return `builder-accordion-detail builder-accordion-detail-${open.includes(index) ? "open" : "closed"}`;
}
function onClick(index) {
    if (open.includes(index)) {
        open = onlyOneAtATime() ? [] : open.filter((item) => item !== index);
    }
    else {
        open = onlyOneAtATime() ? [index] : open.concat(index);
    }
}
$: onlyOneAtATime = () => {
    return Boolean(grid || oneAtATime);
};
$: accordionStyles = () => {
    const styles = {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "column",
        ...(grid && {
            flexDirection: "row",
            alignItems: "flex-start",
            flexWrap: "wrap",
        }),
    };
    return styles;
};
$: accordionTitleStyles = () => {
    const shared = {
        display: "flex",
        flexDirection: "column",
    };
    const styles = {
        ...shared,
        alignItems: "stretch",
        cursor: "pointer",
    };
    return Object.fromEntries(Object.entries(styles).filter(([_, value]) => value !== undefined));
};
$: openGridItemOrder = () => {
    let itemOrder = null;
    const getOpenGridItemPosition = grid && open.length;
    if (getOpenGridItemPosition && document) {
        const openItemIndex = open[0];
        const openItem = document.querySelector(`.builder-accordion-title[data-index="${openItemIndex}"]`);
        let subjectItem = openItem;
        itemOrder = openItemIndex;
        if (subjectItem) {
            let prevItemRect = subjectItem.getBoundingClientRect();
            while ((subjectItem = subjectItem && subjectItem.nextElementSibling)) {
                if (subjectItem) {
                    if (subjectItem.classList.contains("builder-accordion-detail")) {
                        continue;
                    }
                    const subjectItemRect = subjectItem.getBoundingClientRect();
                    if (subjectItemRect.left > prevItemRect.left) {
                        const index = parseInt(subjectItem.getAttribute("data-index") || "", 10);
                        if (!isNaN(index)) {
                            prevItemRect = subjectItemRect;
                            itemOrder = index;
                        }
                    }
                    else {
                        break;
                    }
                }
            }
        }
    }
    if (typeof itemOrder === "number") {
        itemOrder = itemOrder + 1;
    }
    return itemOrder;
};
$: accordionDetailStyles = () => {
    const styles = {
        ...{
            order: typeof openGridItemOrder() === "number"
                ? openGridItemOrder()
                : undefined,
        },
        ...(grid && {
            width: "100%",
        }),
    };
    return Object.fromEntries(Object.entries(styles).filter(([_, value]) => value !== undefined));
};
let open = [];
</script>

<div style={stringifyStyles(accordionStyles())} class="builder-accordion">
  {#each items as item, index}
    <div
      style={stringifyStyles({
        ...accordionTitleStyles(),
        width: grid ? gridRowWidth : undefined,
        ...{
          order:
            openGridItemOrder() !== null
              ? convertOrderNumberToString(index)
              : convertOrderNumberToString(index + 1),
        },
      })}
      class={getAccordionTitleClassName(index)}
      data-index={index}
      on:click={(event) => {
        onClick(index);
      }}
    >
      <Blocks
        blocks={item.title}
        path={`items.${index}.title`}
        parent={builderBlock.id}
        context={builderContext}
        registeredComponents={builderComponents}
        linkComponent={builderLinkComponent}
      />
    </div>

    {#if open.includes(index)}
      <div
        style={stringifyStyles(accordionDetailStyles())}
        class={getAccordionDetailClassName(index)}
      >
        <Blocks
          blocks={item.detail}
          path={`items.${index}.detail`}
          parent={builderBlock.id}
          context={builderContext}
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
        />
      </div>
    {/if}
  {/each}
</div>